import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {IdexService} from 'app/idex.service';
import {SelectionModel} from '@angular/cdk/collections';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {MatSort} from '@angular/material/sort';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';

@Component({
   selector: 'app-auto-approve',
   templateUrl: './auto-approve.component.html',
   styleUrls: ['./auto-approve.component.css']
})
export class AutoApproveComponent implements AfterViewInit {
   isLoadingResults = false;
   isRateLimitReached = false;
   resultsLength = 0;
   tabType: any;
   errorMessage: any;
   public filterValue: any;

   selectTabIndex = 0;
   clickActive: boolean;
   selectedRowIndex: number;
   displayedColumns = ['no', 'template_name', 'create_by', 'last_update_date', 'auto'];
   tpDataSource: MatTableDataSource<TemplateList>;
   selection = new SelectionModel<TemplateList>(true, []);
   templateData: TemplateList[] = [];
   filterTpValue: any;
   pageSize = 50;
   searching: any;
   searchFocused: boolean;
   preventBlur: boolean;
   searchResult: any[];
   searchvalue: any;
   private timer: any;
   sortOrder = 'template_name';
   sortDirect = 'asc';
   sortOrderTmp: string;
   sortDirectTmp: string;
   private page = 0;

   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;

   constructor(protected service: IdexService,
               private dialog: MatDialog,
               public toast: Toast,
               public translate: TranslateService,
               private router: Router) {
      const tpSort = localStorage.getItem('tpSort');
      const tpSortDirect = localStorage.getItem('tpSortDirect');
      const tpPageIndex = localStorage.getItem('tpPageIndex');
      const tpPageSize = localStorage.getItem('tpPageSize');

      if (tpSort) {
         this.sortOrderTmp = tpSort;
         this.sortOrder = this.sortOrderTmp;
         localStorage.removeItem('tpSort');
      }

      if (tpSortDirect) {
         this.sortDirectTmp = tpSortDirect;
         this.sortDirect = this.sortDirectTmp;
         localStorage.removeItem('tpSortDirect');
      }

      if (tpPageIndex) {
         this.page = parseInt(tpPageIndex, 10);
         localStorage.removeItem('tpPageIndex');
      } else {
         this.page = -1;
      }

      if (tpPageSize) {
         this.pageSize = parseInt(tpPageSize, 10);
         localStorage.removeItem('tpPageSize');
      } else {
         this.pageSize = 50;
      }
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;

         if (this.page !== -1) {
            this.paginator.page = this.page;
         } else {
            this.paginator.page = 0;
         }

         this.getAutoApproveList('load');
      }, 0);
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.tabType = 'M';
      } else if (indexSelected === 1) {
         this.tabType = 'S';
      }

      this.selection.clear();
   }

   getAutoApproveList(type) {
      this.loader.show();

      merge(this.paginator.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResults = true;
               if (this.paginator.size !== undefined) {
                  this.pageSize = this.paginator.size;
               }

               const itemSearch = sessionStorage.getItem('tpSearch') || '';
               this.filterTpValue = itemSearch;
               this.searching = itemSearch;
               if (this.filterTpValue === undefined) {
                  this.filterTpValue = '';
               }

               let sort = 'template_name';
               let order = 'asc';
               if (this.sortOrderTmp) {
                  sort = this.sortOrderTmp;
                  this.sortOrderTmp = undefined;

                  if (this.sortDirectTmp) {
                     order = this.sortDirectTmp;
                     this.sortDirectTmp = undefined;
                  }
               } else if (this.sort) {
                  sort = this.sort.active;
                  order = this.sort.direction;
               }

               if (type === 'sort') {
                  this.paginator.page = 0;
               } else if (this.page !== -1) {
                  this.paginator.page = this.page;
                  this.page = -1;
               }

               return this.service.getAutoApproveAll(
                  this.pageSize, this.paginator.page, sort, order, this.filterTpValue, 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.resultsLength = data.totalCount;
               this.templateData = data.items;
               this.tpDataSource = new MatTableDataSource(this.templateData);
               if (this.paginator.page !== data.pageIndex) {
                  this.paginator.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResults = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReached = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.tpDataSource.data = data);
   }

   activeAutoApprove(tpId: any, wfId: any, name: any, active: any) {
      this.clickActive = true;
      const templateId = tpId.innerHTML;
      const templateName = name.innerHTML;
      const workflowId = wfId.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.enableAutoApprove(templateId, workflowId, templateName)
            .subscribe((response) => {
               this.toast.success(response);
            });
      } else {
         this.service.disableAutoApprove(templateId, templateName)
            .subscribe((response) => {
               this.toast.warn(response);
            });
      }
   }

   highlight(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.no;

         this.setSortPaging();
         this.openEditTemplate(row);
      }
      this.clickActive = false;
   }

   onSearch(input: any, filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.filterValue = filterValue.trim(); // Remove whitespace
         this.filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

         this.filterTpValue = filterValue;

         sessionStorage.setItem('tpSearch', this.filterTpValue);
         this.setSortPaging();
         this.getAutoApproveList('search');
         input.blur();
      }
   }

   setSortPaging() {
      if (this.sort) {
         localStorage.setItem('tpSort', this.sort.active);
         localStorage.setItem('tpSortDirect', this.sort.direction);
      }
      if (this.paginator) {
         localStorage.setItem('tpPageIndex', this.paginator.page.toString());
         localStorage.setItem('tpPageSize', this.paginator.size.toString());
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getAutoApproveAll(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   openEditTemplate(row) {
      this.router.navigate(['/create-template'],
         {
            queryParams: {
               p: JSON.stringify({
                  id: row.templateId,
                  mode: 'edit',
                  auto: 't',
               })
            }
         });
   }
}

export interface TPInfo {
   items: TemplateList[];
   totalCount: number;
   pageIndex: number;
}

export interface TemplateList {
   no: number;
   templateId: number;
   templateName: string;
   active: boolean;
   createDate: string;
   createBy: string;
   lastUpdateDate: string;
   lastUpdateBy: string;
}
